const setTopOfHtmlElementThroughStyle = (element: any, top: number, isSpinningOnlyOne: boolean) => {
    if (isSpinningOnlyOne) 
        element.style.top = `${top}px`;
    
    if (!isSpinningOnlyOne)
        element.style.top = `${top}px`;
}

export default setTopOfHtmlElementThroughStyle;